<template>
    <!-- 左侧滑动导航栏组件 -->
    <van-popup v-model="popupData.showA" :style="{ width: '30%', height: '100%' }" position="left" :lock-scroll="false">
        <van-sidebar v-model="key" :style="{ width: '100%' }" :overflow="true">
            <van-sidebar-item v-for="(item, index) in list" :key="item.title" :title="item.title"
                @click="onClick(index, item.path)" v-if="isShow(item)" />
        </van-sidebar>
    </van-popup>
</template>

<script>
import urlConfig from "../../../ApiConfig.js"
export default {
    name: 'leftPopup',
    props: ["", 'activeKey'],
    data() {
        return {
            popupData: {
                city: "",
                version: "",
                riderid: "",
                requester: "",
                showA: false,
                admin: '',
                groupid: '',
                lon: '',
                lat: ''
            },
            list: [
                {
                    title: "城市管理",
                    path: "/SuperRider/serverSwitch"
                },
                {
                    title: "骑手管理",
                    path: "/SuperRider/orderListqsgl"
                },
                {
                    title: "商家列表",
                    path: "/SuperRider/MarketList"
                },
                {
                    title: "订单列表",
                    path: "/SuperRider/orderList"
                },
                {
                    title: "添加满减补贴活动",
                    path: "/SuperRider/orderList3"
                },
                {
                    title: "活动列表",
                    path: "/SuperRider/ActiveList"
                },
                {
                    title: "商家入驻",
                    path: "/SuperRider/MarketRegistration"
                },
                {
                    title: "资金明细",
                    path: "/MerchantProject/Finance"
                },
                {
                    title: "快递站点入驻",
                    path: "/SuperRider/siteEntry"
                },
                {
                    title: "意见反馈",
                    path: "/SuperRider/Feedback"
                },
                // {
                //     title: "超级骑手推送",
                //     path: "/SuperRider/Pushnotification"
                // },
                {
                    title: "骑手订单排行",
                    path: "/SuperRider/rider_order_ranking"
                },
                {
                    title: "活动中心",
                    path: "/ActivityCenter"
                }

            ],
            key: '',
            allowShow: true,
            propagandist: false,
        }
    },
    created() {
        this.key = this.activeKey
        console.log("popupData.showA")
        this.isPropagandist();
    },
    methods: {
        isShow(item) {
            if (item.title == "活动中心") {
                return this.propagandist;
            } else {
                return true;
            }
        },
        /**
         * 查看超级骑手是否为宣传员
         */
        async isPropagandist() {
           // urlConfig.isPropagandist = "http://127.0.0.1:8995/Important/is/propagandist"
            const res = await this.$axios({
                url: urlConfig.isPropagandist,
                params: {
                    riderId: new URLSearchParams(window.location.search).get("riderid"),
                    city: new URLSearchParams(window.location.search).get("city"),
                }
            })
            this.propagandist = res.data;
        },
        onClick(index, path) {
            this.key = index;
            this.popupData.showA = false;
            this.$router.push({
                path,
                query: this.popupData
            });
        },
        /**
         * 填充数据
         * @param self
         * @returns {{}}
         */
        getData(self) {
            this.popupData.city = self.city;
            this.popupData.version = self.version;
            this.popupData.riderid = self.riderId;
            this.popupData.requester = self.requester;
            this.popupData.admin = self.admin;
            this.popupData.groupid = self.groupid;
            this.popupData.riderName = self.riderName;
            this.popupData.lon = self.lon;
            this.popupData.lat = self.lat;

            this.touch()
            return this.popupData
        },
        /**
         * 绑定事件
         */
        touch() {
            var that = this;
            var touchstartX = "";
            if (!this.allowShow) {
                return;
            }
            window.ontouchstart = function (event) {
                touchstartX = event.changedTouches[0].screenX;//得到手指按下点的X轴值
            }
            var touchmoveX = "";
            window.ontouchmove = function (event) {
                touchmoveX = event.changedTouches[0].screenX;//监听拉动过程中手指的位置
                if (touchmoveX * 1 <= touchstartX) {//证明手指不是在右拉  而是左拉   左拉不做处理
                    return;
                }
                if ((touchmoveX - touchstartX) * 1 >= 100) {
                    that.popupData.showA = true;
                }
            }
        },
        /**
         * 绑定操作
         */
        onAllowShow() {
            window.ontouchstart = undefined;
            window.ontouchmove = undefined;
        },
        /**
         * 显示popup
         */
        showLeftMenu() {
            this.popupData.showA = true;
        }
    }
}
</script>

<style scoped lang="less">
/deep/ .van-sidebar-item {
    padding: 15px 0px !important;
    font-size: 12px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/SuperRider/template/popup.vue